/*jslint browser: true, sloppy: true, nomen: true, maxerr: 50, indent: 4 */
"use strict";
(function(){
    $.fn.qtip.zindex = 900;

    var QtipManager = {
        namespace     : "fotobook_qtip",
        type1selector : ".ajax-tooltip[data-qtip-selector],.ajax-tooltip[data-qtip-text]",

        activate      : function(element) {
            var $closest = element.closest(".jspScrollable"),
                jsp = $closest.data("jsp"),
                trigerrer = function(){
                    jsp.scrollToElement(element, true);
                };
            if (jsp){
                $closest.one("jsp-user-scroll-x jsp-user-scroll-y", function(e){
                    element.trigger(QtipManager.namespace);
                });
                trigerrer();
            } else {
                setTimeout(function(){
                    jsp = element.closest(".jspScrollable").data("jsp");
                    if (jsp){
                        trigerrer();
                    }
                    element.trigger(QtipManager.namespace);
                    setTimeout(function(){
                        if (element.data('qtip')){
                            element.data('qtip').show();
                            element.data('qtip').reposition(null, false);
                        }
                    }, 500);

                }, 150);
            }
        },
        hideInvisible : function() {
            $(".qtip:visible").each(function(){
                var qtip = $(this).data("qtip");
                if (!qtip.target.length || !qtip.target.is(":visible")) {
                    $(this).qtip("hide");
                }
            });
        },
        hideAll: function(){
            $(".qtip").hide();
        },

        showImagePreview(event) {
            const $this = $(event.currentTarget),
                albumPhotosLength = $this.closest('.album-fotos').length;

            let mainParent = $(event.currentTarget.parentNode),
                img = mainParent.find('img:first'),
                commandClass = '',
                previewClass = '',
                previewPhotoControlsCommand = '';

            if (albumPhotosLength) {
                mainParent = $this.closest('.outer');
                img = mainParent.find('.album_image:first');
            } else {
                previewClass = 'uploading-foto-preview ';
                previewPhotoControlsCommand = 'hidden-command';
                if (img.closest('.selectable').hasClass('no-original')) {
                    commandClass = 'hidden-command';
                }
            }

            if (!img.length || !img[0].complete || !img[0].width) {
                return;
            }

            const imageData = img.data('info');
            const imgName = imageData ? imageData.name : '';

            $this.qtip({
                content: {
                    text: [
                        '<div class="qtip-foto-preview ', previewClass,
                        img.closest('.selectable').hasClass('no-original') ? 'no-original-preview' : '',
                        '" data-id="', img.attr('data-id'),'">',
                        Fotobook.noOriginalTmpl(),
                        '<svg x="0" y="0" width="100%" height="100%">',
                        '<image width="100%" height="100%" class="image" xlink:href="', img.attr('src'), '" preserveAspectRatio="xMidYMid meet" />',
                        '</svg>',
                        '<div class="preview-foto-controls ', previewPhotoControlsCommand, '">',
                        '<div class="preview-foto-control left-control oe-sprite-image"></div>',
                        '<div class="preview-foto-control right-control oe-sprite-image"></div>',
                        '</div>',
                        '</div>',
                        '<div class="preview-bottom-panel">',
                        '<div class="commands">',
                        '<div class="ajax-tooltip close-target edit-icons-sprite-ba" data-qtip-selector="photobook-tooltipText-close"></div>',
                        '</div>',
                        '</div>',
                        '<div class="image-info">',
                        '<div class="image-name">',imgName,'</div>',
                        // '<div style="float:left">',imgDimension,'</div>',
                        // '<div style="float:right">',imgSize,'</div>',
                        '</div>',
                    ].join(''),
                },
                overwrite: true,
                position: {
                    adjust: {
                        mouse: false,
                        method: 'flip flip',
                    },
                    my: 'left top',
                    at: 'top left',
                    viewport: $(window),
                    target: [$this.offset().left, $this.offset().top + $this[0].clientHeight],
                },
                events:{
                    hide(event, api){
                        if($(api.tooltip[0]).is(':hover')){
                            return false;
                        }
                    },
                },
                hide: {
                    delay: 300,
                    fixed: true,
                    event: 'mouseout',
                },
                show: {
                    event: event.type,
                    ready: true,
                    solo: '.qtip-image-preview',
                },
                style: {
                    tip: {
                        corner: false,
                    },
                    classes: 'qtip-light img-prev qtip-image-preview coloured-border',
                },
            }, event);
        },
    };

    var _qtip_type_1_activated = false;
// Type1 delegated tooltips
    $(document)
        .off("."+QtipManager.namespace)
        .on('mouseover', '#added-photos .selected.image-controls-hover', (event) => {
            QtipManager.showImagePreview(event);
        })
    .on("mouseover", QtipManager.type1selector, function(event) {
        var $this = $(this),
            $html = $("html"),
            qtip_text = this.getAttribute("data-qtip-text"),
            qtip_selector = this.getAttribute("data-qtip-selector"),
            container;

        if ($(event.target).closest(".qtip-disabled", this).length){
            return;
        }

        if ((qtip_text === undefined && qtip_selector === undefined) || _qtip_type_1_activated){
            return;
        }
        if ($this.closest(".book").length) {
            return;
        }

        if (event.target && (event.target != this) && (event.target.nodeName.toLowerCase() == "option")){
            $this.qtip_destroy();
            return;
        }

        container = $this.closest(".site_content");
        if (!container.length){
            container = $("body");
        }

        $this.qtip({
            "content": function(){
                var text = qtip_selector;
                if (text) {
                    text = t(text);
                } else {
                    text = qtip_text;
                }
                return text;
            },
            "position": {
                "adjust" : {
                    "x": 5,
                    "y": 6,
                    "method": "flipinvert",
                },
                "target"   : "mouse",
                "viewport" : $(window),
                "container": container,
            },
            "style": {
                "classes": "qtip-light qtip-shadow small-tip qtip-type1 coloured-border",
                "tip": {
                    "corner": true,
                },
            },
            "show": {
                "delay": 200,
                "solo": ".qtip-type1",
                "ready": true,
            },
            "events": {
                "show": function(event, api){
                    if (
                        api.elements.target.closest(".commands-button.disabled").length ||
                        api.elements.target.is(".tb-popup.active,.editing,.qtip-disabled,.locked,.empty,ui-draggable-dragging") ||
                        ($html.hasClass("preview") && api.elements.target.hasClass("nopreview")) ||
                        (api.elements.target.find('.ajax-tooltip-autoshow').length)
                    ){
                        return false;
                    }
                },
            }
        }, event);
        _qtip_type_1_activated = true;
        setTimeout(function(){
            _qtip_type_1_activated = false;
        }, 0);
    })
// Type2 delegated tooltips
    .on("click."+QtipManager.namespace, ".qtip-image-preview .preview-foto-control", function(event){
        var $this = $(this),
            tooltip = $this.closest('.qtip-foto-preview'),
            id = tooltip.attr('data-id'),
            prevNext = $this.hasClass('left-control') ? 'prev' : 'next',
            image = Fotobook.fotoManager.imagesTab.getImage(id, prevNext, $("html").hasClass(Fotobook.classes.HIDE_USED_FOTOS)),
            $img1, $img2,
            scrollPane = $(".images-carousel-wrapper"),
            api = scrollPane.data('jsp'),
            delta = 0,
            bgButtons = $this.closest('.qtip-content').find('.set-bg-foto');

        if (typeof image !== undefined){
            tooltip.find(".image").attr("xlink:href", Fotobook.createStorageUrl(image.preview_path + '?v=' + image.version));
            tooltip.attr('data-id', image.id);
            tooltip.removeClass('no-original-preview');
            bgButtons.removeClass('hidden-command');
            if(!image.originalExists){
                tooltip.addClass('no-original-preview');
                bgButtons.addClass('hidden-command');
            }
            var $albumPhotos = $('.album-fotos');
            $img1 = $albumPhotos.find('.foto_' + image.id + ':visible');
            $img2 = $albumPhotos.find('.foto_' + id + ':visible');
            delta = Math.abs($img1.offset().left - $img2.offset().left);
            switch(prevNext){
                case 'prev':
                    if(tooltip.offset().left > $img1.offset().left){
                        api.scrollByX(-delta, false);
                    }
                    break;
                case 'next':
                    if(tooltip.offset().left < $img1.offset().left){
                        api.scrollByX(delta, false);
                    }
                    break;
                default:
                    break;
            }
        }
    })
    .on("click."+QtipManager.namespace, ".qtip-image-preview .close-target", function(event) {
        $(this).closest(".qtip").hide();
    })
    .on("dialogclose." + QtipManager.namespace, function(event){
        var dialog = $(event.target).closest(".ui-dialog")[0];
        $(".qtip:visible").each(function(){
            if ($($(this).data("qtip").target).closest(".ui-dialog")[0] == dialog) {
                $(this).qtip("hide");
            }
        });
    })
    .on("dialogopen." + QtipManager.namespace, function(event) {
        var dialog = $(event.target).closest(".ui-dialog")[0];
        $(".qtip:visible").each(function(){
            if ($($(this).data("qtip").target).closest(".ui-dialog")[0] != dialog) {
                $(this).qtip("hide");
            }
        });
    })
// События, по которым подсказки закрываются во избежание нежелательных эффектов,
// таких как перемещение подсказок в направлении левого верхнего угла, уезжание
// за пределы аккордеона и так далее
    .on("click." + QtipManager.namespace, function(event){
        if (!$(event.target).closest(".qtip").length) {
            QtipManager.hideAll();
        }
    })
    .on("dragstart." + QtipManager.namespace, QtipManager.hideAll)
    .on("jsp-scroll-y." + QtipManager.namespace, QtipManager.hideInvisible)
    ;

    Fotobook.QtipManager = QtipManager;
})();

$.fn.qtip_destroy = function(){
    this.each(function(){
        var qtip = $(this).data("qtip");
        if (qtip){
            qtip.destroy();
        }
    });
    return this;
};
